import SearchSelect from "Components/molecule/inputs/search-select"
import { IDocQueryParams } from "../../../../models/document"
import SecondaryButton from "../../../atoms/buttons/secondary-button"
import HorizontalContainer from "Components/atoms/containers/horiozontal-container"
import SearchFormContainer from "Components/atoms/containers/search-form-container"

interface SearchDocumentTemplateProps {
    values: IDocQueryParams,
    onChange: (_field: keyof IDocQueryParams, _value: string) => void
    handleClear: () => void
    handleBack: () => void
}

const SearchDocumentsForm = ({ values, onChange, handleClear, handleBack }: SearchDocumentTemplateProps) => {
    return <SearchFormContainer
        inputs={<>
            <SearchSelect
                label={"Employee Type"}
                options={[
                    { value: '', label: 'All Types' },
                    { value: 'Consultant', label: 'Consultant' },
                    { value: 'Employee', label: 'Employee' },
                ]}
                onChange={(o) => onChange('employeeType', o?.value ?? '')}
                value={values.employeeType || ''}
            />
            <SearchSelect
                label={"Province"}
                options={[
                    { value: '', label: 'All Provinces' },
                    { value: 'BC', label: 'British Columbia' },
                    { value: 'AB', label: 'Alberta' },
                ]}
                value={values.province || ''}
                onChange={(o) => onChange('province', o?.value ?? '')}

            />

            <SearchSelect
                label={"Engineer"}
                options={[
                    { value: '', label: 'All' },
                    { value: 'Yes', label: 'Yes' },
                    { value: 'No', label: 'No' },
                ]}
                onChange={(o) => onChange('engineer', o?.value ?? '')}
                value={values.engineer || ''}
            />

            <SearchSelect
                label={"Role"}
                options={[
                    { value: '', label: 'All Roles' },
                    { value: 'Employee', label: 'Employee' },
                    { value: 'Lead', label: 'Lead' },
                    { value: 'Manager', label: 'Manager' },
                    { value: 'Director', label: 'Director' },
                ]}
                onChange={(o) => onChange('role', o?.value ?? '')}
                value={values.role || ''}
            />

            <SearchSelect
                label={"Wage Type"}
                options={[
                    { value: '', label: 'All Types' },
                    { value: 'Salary', label: 'Salary' },
                    { value: 'Hourly', label: 'Hourly' },
                ]}
                onChange={(o) => onChange('wageType', o?.value ?? '')}
                value={values.wageType || ''}
            />
        </>}
        clearSearchButton={<>
            <SecondaryButton onClick={handleClear}>Clear</SecondaryButton>
        </>}

    />
}

export default SearchDocumentsForm